import type {RouteObject} from 'react-router';
import ToPlaceDashboard from './ToPlaceDashboard';

/**
 * A place's pages (FE #331 MR3a), under its frame (`PlaceLayout`: the
 * header, the star, the Dashboard and Forecast tabs). The Dashboard is the
 * index, so a link to `/app/places/:placeId` from before the tabs still
 * opens on it; the sun and moon pages are where its cards' titles lead
 * (`navigate('sun')`, relative), as on a station, and its warnings are the
 * station's warnings page, under the place.
 */
export const placeRoutes: RouteObject[] = [
  {
    path: '',
    lazy: () => import('../../../screens/myWeather/PlacePage/PlaceDashboard'),
  },
  {
    path: 'forecast',
    lazy: () => import('../../../screens/myWeather/PlacePage/PlaceForecast'),
  },
  {
    path: 'sun',
    lazy: () => import('../../../screens/myWeather/PlacePage/PlaceSun'),
  },
  {
    path: 'moon',
    lazy: () => import('../../../screens/myWeather/PlacePage/PlaceMoon'),
  },
  // Its official warnings (MR3b): the station's page, read from the
  // place's provider in the frame (`LocationWarningsProvider`).
  {
    path: 'warnings',
    lazy: () =>
      import('../../../screens/stations/StationDetail/WeatherWarnings'),
  },
  {
    // The URL carries the selected warning, so a detail can be linked to.
    path: 'warnings/:warningId',
    lazy: () =>
      import('../../../screens/stations/StationDetail/WeatherWarnings'),
  },
  {
    path: '*',
    element: <ToPlaceDashboard />,
  },
];
